import _extends from "reshow-runtime/es/helpers/extends";
import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React from 'react';
import reactStyle from '../../src/lib/styles/index';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';

var Progress = function Progress(props) {
  var barProps = props.barProps,
      children = props.children,
      className = props.className,
      percent = props.percent,
      style = props.style,
      styles = props.styles,
      others = _objectWithoutProperties(props, ["barProps", "children", "className", "percent", "style", "styles"]);

  var _ref = barProps || {},
      barStyle = _ref.style,
      barStyles = _ref.styles,
      otherBarProps = _objectWithoutProperties(_ref, ["style", "styles"]);

  var classes = mixClass(className, 'progress');
  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, others, {
    className: classes,
    styles: [reactStyle(_objectSpread({
      fontSize: 0
    }, style), null, false), styles]
  }), /*#__PURE__*/React.createElement(SemanticUI, _extends({
    className: "bar"
  }, otherBarProps, {
    styles: [reactStyle(_objectSpread({
      width: percent + '%'
    }, barStyle), null, false), barStyles]
  })), children);
};

export default Progress;